import { SEO_CONFIG } from '@/config/seoConfig';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function getPageName(pathname: string): string {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  const seoEntry = SEO_CONFIG[normalized] ?? SEO_CONFIG[pathname];
  if (seoEntry?.title) {
    return seoEntry.title.replace(/\s*-\s*Yodlee ID Portal$/i, '').trim();
  }

  const parts = normalized.split('/').filter(Boolean);
  if (parts.length > 0) {
    return parts[parts.length - 1]
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  return 'Page';
}

/**
 * Announces route changes to screen readers via an aria-live region.
 * Place once inside the router context (e.g. in App.tsx).
 */
export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    setAnnouncement('');
    const frameId = requestAnimationFrame(() => {
      setAnnouncement(`${getPageName(pathname)} page loaded successfully.`);
    });
    return () => cancelAnimationFrame(frameId);
  }, [pathname]);

  return (
    <div
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  );
}
